import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LoansPage.css';

export default function LoansPage() {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.querySelector('.close-sidebar');
    if (hamburger && sidebar && closeSidebar) {
      hamburger.onclick = () => sidebar.classList.add('active');
      closeSidebar.onclick = () => sidebar.classList.remove('active');
    }
    return () => {
      if (hamburger) hamburger.onclick = null;
      if (closeSidebar) closeSidebar.onclick = null;
    };
  }, []);

  return (
    <main className="loans-page" style={{ paddingBottom: 0 }}>
      <nav className="regular-navbar">
        <Link className="logo" to="/">
          <img src="/logo.jpg" alt="company logo" />
        </Link>
        <div className="hamburger">
          <img src="/static/media/hamburger-black.c116047ebd06e70caac47be95fd90698.svg" alt="menu" />
        </div>
        <div className="links">
          <div className="void"></div>
          <div className="cont">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/loans">Loans</Link></li>
              <li><Link to="/savings-investments">Savings & Investment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <div className="btns"><button className="transparent"><Link to="/register">Register</Link></button><button className="blue"><Link to="/login">Sign In</Link></button></div>
          </div>
        </div>
      </nav>
      <div id="sidebar">
        <ul>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className="close-sidebar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
          </div>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About us</Link></li>
          <li><Link to="/loans">Loans</Link></li>
          <li><Link to="/savings-investments">Savings & Investment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <div className="btnss" style={{ marginTop: 14 }}>
            <button className="transparent" style={{ marginRight: 5 }}><Link to="/register">Register</Link></button>
            <button className="blue"><Link to="/login">Sign In</Link></button>
          </div>
        </ul>
      </div>
      <header className="page-header">
        <div className="text-info">
          <h1>Loans</h1>
          <p>From financing a wedding to covering unexpected expenses. With fixed interest rates and predictable monthly payments, a personal loan can provide the peace of mind you need to focus on what really matters.</p>
          <button className="white"><Link to="/login">Get a loan today</Link></button>
        </div>
        <div className="img"><img src="/static/media/loans-header.a6b53f24460b8c6b109f.webp" alt="Loans" /></div>
      </header>
      <section className="loan-options">
        <h2>Here are just a few of the loan options we offer</h2>
        <div className="cards">
          <div className="card">
            <div className="img"><img src="/static/media/personal-loan.d2444d5468a2968b6c6f.webp" alt="personal loan" /></div>
            <div className="text">
              <h4>Personal Loan</h4>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/payday-loan.cc1963ea1a252b60eda8.webp" alt="payday loan" /></div>
            <div className="text">
              <h4>PayDay Loan</h4>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/salary-advance-loan.1f87ced3853c44659f65.webp" alt="salary advance loan" /></div>
            <div className="text">
              <h4>Salary Advance</h4>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/vehicle-loan.7cc60b48e12ceda3e18d.webp" alt="vehicle loan" /></div>
            <div className="text">
              <h4>Vehicle Loan</h4>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/home-loan.b2ab9cf85f851b024e00.webp" alt="Home loan" /></div>
            <div className="text">
              <h4>Home Loan</h4>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/vacation-loan.c8257c3b57d3fd82221c.webp" alt="Vacation loan" /></div>
            <div className="text">
              <h4>Vacation Loan</h4>
            </div>
          </div>
        </div>
      </section>
      <article className="financial-freedom">
        <div className="text">
          <h2>Take a Step Towards Financial Freedom</h2>
          <p>Ready to start achieving your financial goals? Open an account today and discover the benefits of banking with us all from the comfort of your home.</p>
          <button className="white"><Link to="/register">Open an account today</Link></button>
        </div>
        <div className="img"><img src="/static/media/financial-freedom.81826f816f2e9f3fe1c9.png" alt="" /></div>
      </article>
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo"></div>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
